<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  @if (user | hasEitherPerm: ['cauth.view_user']) {
    <div class="top-menu mx-2">
      <div tuiDropdownOpen [tuiDropdownMaxHeight]="700" [tuiDropdown]="umenu">
        <tui-icon [icon]="'mat::eye'" class="tm-icon"></tui-icon>
      </div>
    </div>

    <ng-template #umenu>
      <tui-data-list role="menu">
        <tui-opt-group>
          @if (user | hasAllPerms: ['cauth.view_user']) {
            <a class="m-option" tuiOption routerLink="/users">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'@tui.user'"></tui-icon>
                </div>
                <div class="m-option-text mx-3" i18n>Users</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ['core.view_company']) {
            <a class="m-option" tuiOption routerLink="/companies">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'mat::company'"></tui-icon>
                </div>
                <div class="m-option-text mx-3" i18n>Companies</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ['core.view_vesseltype']) {
            <a class="m-option" tuiOption routerLink="/vessel-types">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'@tui.material.filled.category'"></tui-icon>
                </div>
                <div class="m-option-text mx-3">Vessel Types</div>
              </div>
            </a>
          }
          @if (user | hasAllPerms: ['core.view_vesselclass']) {
            <a class="m-option" tuiOption routerLink="/vessel-classes">
              <div class="d-flex align-items-center">
                <div class="m-option-icon">
                  <tui-icon [icon]="'@tui.material.filled.list_alt'"></tui-icon>
                </div>
                <div class="m-option-text mx-3">Vessel Classes</div>
              </div>
            </a>
          }
        </tui-opt-group>
      </tui-data-list>
    </ng-template>
  }
}
